import { gql } from '@apollo/client';
import { ACTIVITY_FEED_FRAGMENT } from './acitivity-feed.fragments';

/**
 * The feed itself. With `rootsOnly` it returns only the activities that are not nested inside
 * another one.
 *
 * Flat by design: the feed carries no children at all. Selecting them made the engine join the
 * `children` relationship — and through it the children's own references — inside the feed's
 * aggregation, which cost far more than the prefetch saved. Every nested level, the first included,
 * comes from `GET_CHILD_ACTIVITY_QUERY` when the user expands that run.
 */
export const GET_ACTIVITY_QUERY = gql`
  query GetActivityFeed($params: GetActivityFeedInput) {
    getActivityFeed(params: $params) {
      records {
        ...ActivityFeedFields
      }
    }
  }
  ${ACTIVITY_FEED_FRAGMENT}
`;

/**
 * The activities one activity caused, addressed by the parent's `actorUid`.
 *
 * A separate query rather than a mode of `getActivityFeed`: expanding a run is scoped by the parent
 * actor alone, so none of the feed's scoping params (`entityEvents`, `identityIds`, `isRoot`,
 * `referenceName`, `rootsOnly`) apply to it.
 *
 * It returns one level, so a run nested inside this response loads through this same query when the
 * user opens it.
 */
export const GET_CHILD_ACTIVITY_QUERY = gql`
  query GetChildActivityFeed($params: GetChildActivityFeedInput!) {
    getChildActivityFeed(params: $params) {
      records {
        ...ActivityFeedFields
      }
    }
  }
  ${ACTIVITY_FEED_FRAGMENT}
`;
